import {
  Circle,
  GoogleMap,
  InfoWindow,
  Marker,
  OverlayView,
} from '@react-google-maps/api';
import { useEffect, useRef, useState } from 'react';

import jobSiteIcon from '../../assets/img/icons/jobsite.svg';
import {
  MapRadiusInfoDiv,
  MapRadiusInfoText,
} from '../FieldServices/JobSites/jobSitesStyles';

const options = {
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
  disableDoubleClickZoom: true,
  gestureHandling: 'cooperative',
  mapId: process.env.REACT_APP_JOB_SITES_MAP_ID,
};

const containerStyle = {
  width: '100%',
  height: '85vh',
  borderLeft: '1px solid #e4e7eb',
  borderRadius: '0 10px 10px 0',
  // marginTop: "10px",
};
const center = {
  lat: 21.424090674479555,
  lng: 39.822141261515604,
};
const circleOptions = {
  strokeColor: '#2aa847',
  strokeWeight: 2,
  fillColor: '#2aa847',
  fillOpacity: 0.2,
};

const getPixelPositionOffset = (offsetWidth, offsetHeight, labelAnchor) => {
  return {
    x: labelAnchor.x,
    // x: offsetWidth + labelAnchor.x,
    y: offsetHeight + labelAnchor.y,
  };
};

const OfficesMap = props => {
  const [showMarkerInfo, setShowMarkerInfo] = useState(false);

  const {
    currentPage,
    sitesList,
    activeSite,
    activeLocation,
    selectSite,
    singleAddressMarker,
    setAddressFromMap,
    setMap,
    radius,
  } = props;

  return (
    <GoogleMap
      options={options}
      mapContainerStyle={containerStyle}
      center={center}
      zoom={13}
      onLoad={map => setMap(map)}
      clickableIcons={false}
      onDblClick={location => setAddressFromMap(location)}
    >
      {currentPage === 'list' ? (
        <>
          {sitesList && sitesList.length
            ? sitesList.map(site => {
                // Check if we have locations for this office
                if (site.locations && site.locations.length > 0) {
                  return site.locations.map(location => {
                    // Determine if this location is active
                    const isLocationActive =
                      activeSite &&
                      activeSite.id === site.id &&
                      activeLocation &&
                      activeLocation.id === location.id;

                    // Default location is the first one when office is selected without a specific location
                    const isDefaultLocation =
                      activeSite &&
                      activeSite.id === site.id &&
                      !activeLocation &&
                      site.locations[0].id === location.id;

                    // Show marker for all locations
                    return (
                      <div key={location.id}>
                        <Marker
                          position={{
                            lat: parseFloat(location.latitude),
                            lng: parseFloat(location.longitude),
                          }}
                          icon={{
                            url: jobSiteIcon,
                            scaledSize: {
                              height:
                                isLocationActive || isDefaultLocation ? 65 : 45,
                              width:
                                isLocationActive || isDefaultLocation ? 65 : 45,
                            },
                          }}
                          onClick={e => {
                            selectSite(site, location);
                          }}
                        />

                        {/* Show radius info for active location */}
                        {(isLocationActive || isDefaultLocation) && (
                          <>
                            <OverlayView
                              position={{
                                lat: parseFloat(location.latitude),
                                lng: parseFloat(location.longitude),
                              }}
                              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                              getPixelPositionOffset={(x, y) =>
                                getPixelPositionOffset(x, y, { x: -30, y: -20 })
                              }
                            >
                              <MapRadiusInfoDiv>
                                <MapRadiusInfoText>
                                  {location.radius || 100} m
                                </MapRadiusInfoText>
                              </MapRadiusInfoDiv>
                            </OverlayView>

                            <Circle
                              center={{
                                lat: parseFloat(location.latitude),
                                lng: parseFloat(location.longitude),
                              }}
                              radius={parseInt(location.radius) || 100}
                              options={circleOptions}
                            />
                          </>
                        )}
                      </div>
                    );
                  });
                } else if (site.latitude && site.longitude) {
                  // Fallback for offices without locations array
                  return (
                    <div key={site.id}>
                      <Marker
                        position={{
                          lat: parseFloat(site.latitude),
                          lng: parseFloat(site.longitude),
                        }}
                        icon={{
                          url: jobSiteIcon,
                          scaledSize: {
                            height:
                              activeSite && activeSite.id === site.id ? 55 : 45,
                            width:
                              activeSite && activeSite.id === site.id ? 55 : 45,
                          },
                        }}
                        onClick={e => {
                          selectSite(site);
                        }}
                      />

                      {activeSite && activeSite.id === site.id && (
                        <>
                          <OverlayView
                            position={{
                              lat: parseFloat(site.latitude),
                              lng: parseFloat(site.longitude),
                            }}
                            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                            getPixelPositionOffset={(x, y) =>
                              getPixelPositionOffset(x, y, { x: -30, y: -20 })
                            }
                          >
                            <MapRadiusInfoDiv>
                              <MapRadiusInfoText>
                                {site.radius || 100} m
                              </MapRadiusInfoText>
                            </MapRadiusInfoDiv>
                          </OverlayView>

                          <Circle
                            center={{
                              lat: parseFloat(site.latitude),
                              lng: parseFloat(site.longitude),
                            }}
                            radius={parseInt(site.radius) || 100}
                            options={circleOptions}
                          />
                        </>
                      )}
                    </div>
                  );
                } else {
                  return null; // Skip offices with no location data
                }
              })
            : null}
        </>
      ) : currentPage === 'details' ? (
        singleAddressMarker ? (
          <>
            <Marker
              position={singleAddressMarker}
              icon={{
                url: jobSiteIcon,
                scale: 20,
              }}
              draggable
              onDragEnd={e => setAddressFromMap(e)}
            />
            <OverlayView
              key={`ovd`}
              position={singleAddressMarker}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              getPixelPositionOffset={(x, y) =>
                getPixelPositionOffset(x, y, { x: -30, y: -20 })
              }
            >
              <MapRadiusInfoDiv>
                <MapRadiusInfoText>{radius} m</MapRadiusInfoText>
              </MapRadiusInfoDiv>
            </OverlayView>
            <Circle
              center={singleAddressMarker}
              radius={radius}
              options={circleOptions}
            />
          </>
        ) : null
      ) : null}
    </GoogleMap>
  );
};

export default OfficesMap;
